import React, { useState } from 'react';

export function PrivacyNoticeModal({ open, onClose }) {
  return (
    <>
      {open && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 1000,
          display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}
          onClick={onClose}>
          <div onClick={e => e.stopPropagation()}
            style={{ background: 'white', borderRadius: '20px 20px 0 0', width: '100%',
              maxWidth: 540, maxHeight: '85vh', overflow: 'hidden',
              display: 'flex', flexDirection: 'column' }}>

            <div style={{ background: 'var(--green-dark)', padding: '20px 24px',
              display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
              <div>
                <div style={{ color: 'white', fontWeight: 700, fontSize: '1rem' }}>Privacy Notice</div>
                <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.8rem' }}>Garden & Groundworks</div>
              </div>
              <button onClick={onClose}
                style={{ background: 'rgba(255,255,255,0.15)', color: 'white', borderRadius: 8,
                  padding: '6px 12px', fontSize: '0.85rem', width: 'auto' }}>Close</button>
            </div>

            <div style={{ overflowY: 'auto', padding: '24px', fontSize: '1rem',
              color: 'var(--text-secondary)', lineHeight: 1.7 }}>

              <p style={{ marginBottom: 16 }}>
                Garden & Groundworks is a sole trader business operated by Dean Patterson,
                Le Val Farm, Route Des Blicqs, St Andrews, Guernsey GY6 8YD
                (<strong>the Service Provider</strong>).
              </p>

              <p style={{ marginBottom: 16 }}>
                The data controller for this website is Dean Patterson, trading as
                Garden & Groundworks, registered with the Guernsey Office of the Data
                Protection Authority (Unique Reference: DPA11692).
              </p>

              <h3 style={{ color: 'var(--green-dark)', marginBottom: 8, marginTop: 20,
                fontSize: '1.1rem' }}>What information we collect</h3>
              <p style={{ marginBottom: 12 }}>When you submit a quote request or use the client portal we collect:</p>
              <ul style={{ paddingLeft: 20, marginBottom: 16 }}>
                <li style={{ marginBottom: 6 }}>Your name, email address and telephone number</li>
                <li style={{ marginBottom: 6 }}>Your site address and description of works requested</li>
                <li style={{ marginBottom: 6 }}>Communications between you and Garden & Groundworks</li>
                <li style={{ marginBottom: 6 }}>Invoice and payment records</li>
                <li style={{ marginBottom: 6 }}>Device notification tokens if you enable push notifications</li>
              </ul>

              <h3 style={{ color: 'var(--green-dark)', marginBottom: 8, marginTop: 20,
                fontSize: '1.1rem' }}>Why we collect it</h3>
              <p style={{ marginBottom: 8 }}>
                Your information is collected and processed on the lawful basis of
                <strong> contract performance</strong> — to respond to your quote request,
                carry out works and manage invoicing — and <strong>legitimate interests</strong>
                for ongoing communication about jobs.
              </p>

              <h3 style={{ color: 'var(--green-dark)', marginBottom: 8, marginTop: 20,
                fontSize: '1.1rem' }}>Who we share it with</h3>
              <ul style={{ paddingLeft: 20, marginBottom: 16 }}>
                <li style={{ marginBottom: 6 }}><strong>Google Firebase</strong> — our secure cloud database and hosting provider</li>
                <li style={{ marginBottom: 6 }}><strong>Brevo</strong> — sends transactional emails on our behalf (e.g. quote confirmations, invoice and payment notifications)</li>
                <li style={{ marginBottom: 6 }}><strong>PayPal</strong> and <strong>SumUp</strong> — payment processing for card transactions only. Garden & Groundworks never sees your card details</li>
                <li style={{ marginBottom: 6 }}><strong>Google reCAPTCHA</strong> — protects our quote request form from spam and automated abuse</li>
                <li style={{ marginBottom: 6 }}><strong>WhatsApp (Meta)</strong> — if you choose to send site photos via the WhatsApp link, that conversation is handled directly within WhatsApp, not by us</li>
                <li style={{ marginBottom: 6 }}>No other third parties. Your data is never sold or used for marketing.</li>
              </ul>

              <h3 style={{ color: 'var(--green-dark)', marginBottom: 8, marginTop: 20,
                fontSize: '1.1rem' }}>How long we keep it</h3>
              <p style={{ marginBottom: 16 }}>
                Client and job records are retained for <strong>6 years</strong> following completion of works,
                in line with standard contract limitation periods under Guernsey law. Payment records are
                retained for <strong>7 years</strong> for accounting purposes.
              </p>

              <h3 style={{ color: 'var(--green-dark)', marginBottom: 8, marginTop: 20,
                fontSize: '1.1rem' }}>Your rights</h3>
              <p style={{ marginBottom: 8 }}>Under the Data Protection (Bailiwick of Guernsey) Law 2017 you have the right to:</p>
              <ul style={{ paddingLeft: 20, marginBottom: 16 }}>
                <li style={{ marginBottom: 6 }}>Access the personal data we hold about you</li>
                <li style={{ marginBottom: 6 }}>Request correction of inaccurate data</li>
                <li style={{ marginBottom: 6 }}>Request erasure of your data (subject to legal retention requirements)</li>
                <li style={{ marginBottom: 6 }}>Object to processing of your data</li>
                <li style={{ marginBottom: 6 }}>Lodge a complaint with the ODPA at odpa.gg</li>
              </ul>

              <h3 style={{ color: 'var(--green-dark)', marginBottom: 8, marginTop: 20,
                fontSize: '1.1rem' }}>Contact</h3>
              <p style={{ marginBottom: 24 }}>
                Contact Dean Patterson at <strong>info@gandg.gg</strong> or
                Le Val Farm, Route Des Blicqs, St Andrews, Guernsey GY6 8YD.
              </p>

              <div style={{ background: 'var(--green-pale)', borderRadius: 10, padding: '12px 16px',
                fontSize: '0.82rem', color: 'var(--green-dark)', marginBottom: 8 }}>
                This notice was last updated July 2026.
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default function PrivacyNotice({ onAccept, onDecline }) {
  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState(false);

  function toggle() {
    const newVal = !checked;
    setChecked(newVal);
    if (newVal) { onAccept(); } else { onDecline(); }
  }

  return (
    <>
      <div style={{ background: 'var(--bg)', borderRadius: 10, padding: '14px 16px',
        border: `1.5px solid ${checked ? 'var(--green-mid)' : 'var(--border)'}`,
        marginBottom: 16 }}>

        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>

          {/* Custom checkbox */}
          <div
            onClick={toggle}
            style={{
              width: 22, height: 22, borderRadius: 5, flexShrink: 0, marginTop: 1,
              border: `2px solid ${checked ? 'var(--green-mid)' : '#aaa'}`,
              background: checked ? 'var(--green-mid)' : 'white',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              cursor: 'pointer', userSelect: 'none',
            }}>
            {checked && (
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                <polyline points="2,7 5.5,10.5 11,3" stroke="white" strokeWidth="2"
                  strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            )}
          </div>

          {/* Label text */}
          <div style={{ fontSize: '1rem', color: 'var(--text-primary)',
            lineHeight: 1.5, cursor: 'pointer' }} onClick={toggle}>
            I agree to Garden & Groundworks storing and processing my personal information
            to respond to this quote request, in accordance with the{' '}
            <span
              onClick={e => { e.stopPropagation(); setOpen(true); }}
              style={{ color: 'var(--green-mid)', fontWeight: 600,
                textDecoration: 'underline', cursor: 'pointer' }}>
              Privacy Notice
            </span>.
          </div>
        </div>
      </div>

      <PrivacyNoticeModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
